export enum StorageItem {
	Auth = 'App/auth',
	AccessToken = 'auth0/access_token', // for auth0
	IdToken = 'auth0/id_token', // for auth0
	Expires_At = 'auth0/expires_at', // for auth0
	Scope = 'auth0/scopes', // for auth0
	SidebarMinimized = 'App/SidebarMinimized',
	Theme = 'App/theme',
	INCOGNITO_MODE = 'App/incognitoMode',
	DISABLED_ACCOUNTS_BANNER = 'App/ZestyDisk/disabledAccountsBanner',
	ColumnManager = 'App/ColumnManager',
	ASGRecollectDataTimer = 'ASG/RecollectDataTimer',
}

export const getItem = (itemName: StorageItem | string): unknown | null => {
	const item = localStorage.getItem(itemName);

	try {
		return item ? JSON.parse(item) : null;
	} catch (e) {
		return null;
	}
};

export const setItem = (itemName: StorageItem | string, value: unknown): void => {
	localStorage.setItem(itemName, JSON.stringify(value));
};

export const removeItem = (itemName: StorageItem | string): void => {
	localStorage.removeItem(itemName);
};
